import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

// Flickity
import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';
